import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import { Z_INDEX } from 'components/utils/const';

export const StyledModal = styled(Dialog)`
    .MuiBackdrop-root {
        background-color: rgba(0, 0, 0, 0.9)
    }


    .MuiDialog-paper {
        border-radius: 16px; /* Apply border-radius to the paper element */
        margin-top: 70px;

        @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
            margin-top: 0px;
        }
    }
`;

export const CloseButton = styled.button`
    position: fixed;
    top: 0;
    right: 0;
    padding: 16px;
    z-index: ${Z_INDEX.overlay};
    color: #fff;
    border: none;
    background: none;
    display: flex;
    align-items: center;
`;